<template>
    <v-layout row wrap class="pb-4">
        <v-flex xs12 class="subheading consent-text font-weight-black">
            {{ $t('form.covid195To11ConfirmConsentToVaccine.title') }}
        </v-flex>
        <v-flex
            xs12
            class="body-1 mb-2 consent-text font-weight-medium"
            v-html="$t('form.covid195To11ConfirmConsentToVaccine.text')" />
        <v-flex>
            <accessible-radio-group
                v-model="value"
                class="body-2 ml-6 mt-0"
                :outline="outline"
                :color="$vuetify.theme.primary"
                :data-meta-id="metadata.id"
                :options="[
                    { label: formattedAriaLabel(
                        metadata[`description${this.upperLocale}`],
                        required
                    ), value: 1 },
                    { label: $t('form.covid195To11ConfirmConsentToVaccine.refuse'), value: 0 }
                ]"
                :mandatory="required"
                :rules="[
                    v => v !== 0 || $t('form.covid195To11ConfirmConsentToVaccine.refuseError'),
                    !required || requiredField()
                ]"
                :id="metadata.name"
                @input="emitValue"
            />
        </v-flex>
    </v-layout>
</template>
<script>
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import AccessibleRadioGroup from '@/components/inputs/AccessibleRadioGroup.vue';

export default {
    name: 'covid511-confirm-consent-to-vaccine',
    components: { AccessibleRadioGroup },
    mixins: [formRules],
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),

    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>

<style lang="scss" scoped>
    .consent-text {
        margin-left: 35px;
        color: rgba(0,0,0,.54);
    }
</style>
